/**
 * Styles for intro request page.
 * Extracted for LLM-friendly file sizes per doctrine.
 */

/**
 * Main styles string for intro request page.
 */
export const introRequestStyles = `
  .intro-loading {
    padding: calc(var(--spacing) * 3);
    text-align: center;
    color: var(--color-text-muted);
  }

  .intro-content {
    margin-top: var(--spacing);
  }

  .intro-form {
    display: flex;
    flex-direction: column;
    gap: var(--spacing);
  }

  .card-preview {
    padding: var(--spacing);
    background: var(--color-surface);
    border-radius: var(--radius);
    border: 1px solid var(--color-border);
    text-align: center;
  }

  .preview-label {
    font-size: 0.85rem;
    color: var(--color-text-muted);
    margin: 0 0 0.5rem 0;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .preview-title {
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0 0 0.25rem 0;
    color: var(--color-text);
  }

  .preview-id {
    font-size: 0.8rem;
    color: var(--color-text-muted);
    margin: 0;
  }

  .safety-notice {
    padding: var(--spacing);
    background: var(--color-warning-bg, #fef3c7);
    border-radius: var(--radius);
    border: 1px solid var(--color-warning-border, #f59e0b);
  }

  .notice-title {
    font-size: 0.95rem;
    font-weight: 600;
    margin: 0 0 0.75rem 0;
    color: var(--color-warning-text, #92400e);
  }

  .notice-list {
    margin: 0;
    padding-left: 1.25rem;
    font-size: 0.85rem;
    color: var(--color-warning-text, #92400e);
    line-height: 1.6;
  }

  .notice-list li {
    margin-bottom: 0.25rem;
  }

  .form-field {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .field-label {
    font-size: 0.9rem;
    font-weight: 500;
    color: var(--color-text);
  }

  .field-input {
    padding: 0.75rem;
    font-size: 0.95rem;
    font-family: inherit;
    border: 1px solid var(--color-border);
    border-radius: var(--radius);
    background: var(--color-surface);
    color: var(--color-text);
    resize: vertical;
    min-height: 100px;
  }

  .field-input:focus {
    outline: none;
    border-color: var(--color-primary);
    box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.1);
  }

  .field-hint {
    font-size: 0.8rem;
    color: var(--color-text-muted);
    text-align: right;
  }

  .checkbox-field {
    padding: var(--spacing);
    background: var(--color-surface);
    border-radius: var(--radius);
    border: 1px solid var(--color-border);
  }

  .checkbox-label {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    cursor: pointer;
  }

  .checkbox-input {
    margin-top: 0.2rem;
    width: 1.25rem;
    height: 1.25rem;
    accent-color: var(--color-primary);
  }

  .checkbox-text {
    font-size: 0.9rem;
    color: var(--color-text);
    line-height: 1.5;
  }

  .form-error {
    padding: 0.75rem;
    background: var(--color-error-bg, #fee2e2);
    border: 1px solid var(--color-error-border, #ef4444);
    border-radius: var(--radius);
    color: var(--color-error-text, #dc2626);
    font-size: 0.9rem;
  }

  .form-actions {
    display: flex;
    flex-direction: column;
    gap: var(--spacing);
    align-items: center;
    padding-top: var(--spacing);
  }

  .submit-button {
    padding: 0.875rem 2rem;
    background: var(--color-primary, #6366f1);
    color: white;
    border: none;
    border-radius: var(--radius);
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease;
    width: 100%;
    max-width: 300px;
  }

  .submit-button:hover:not(:disabled) {
    background: #4f46e5;
  }

  .submit-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .cancel-link {
    display: inline-block;
    padding: 0.5rem 1rem;
    color: var(--color-text-muted);
    text-decoration: none;
    font-size: 0.9rem;
  }

  .cancel-link:hover {
    color: var(--color-text);
  }

  /* Success state */
  .intro-success {
    padding: calc(var(--spacing) * 2);
    text-align: center;
  }

  .success-icon {
    width: 64px;
    height: 64px;
    background: var(--color-success, #22c55e);
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    margin: 0 auto var(--spacing);
  }

  .success-title {
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0 0 0.75rem 0;
    color: var(--color-text);
  }

  .success-message {
    font-size: 1rem;
    color: var(--color-text-secondary);
    margin: 0 0 0.5rem 0;
    line-height: 1.5;
  }

  .success-note {
    font-size: 0.9rem;
    color: var(--color-text-muted);
    margin: 0 0 var(--spacing) 0;
    padding: var(--spacing);
    background: var(--color-surface);
    border-radius: var(--radius);
  }

  .success-actions {
    margin-top: var(--spacing);
  }

  /* Duplicate state */
  .intro-duplicate {
    padding: calc(var(--spacing) * 2);
    text-align: center;
  }

  .duplicate-icon {
    width: 64px;
    height: 64px;
    background: var(--color-info, #3b82f6);
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    margin: 0 auto var(--spacing);
  }

  .duplicate-title {
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0 0 0.75rem 0;
    color: var(--color-text);
  }

  .duplicate-message {
    font-size: 1rem;
    color: var(--color-text-secondary);
    margin: 0 0 0.5rem 0;
    line-height: 1.5;
  }

  .duplicate-note {
    font-size: 0.9rem;
    color: var(--color-text-muted);
    margin: 0 0 var(--spacing) 0;
    padding: var(--spacing);
    background: var(--color-surface);
    border-radius: var(--radius);
  }

  .duplicate-actions {
    margin-top: var(--spacing);
  }

  /* Error state */
  .intro-error {
    padding: calc(var(--spacing) * 2);
    text-align: center;
  }

  .error-icon {
    width: 64px;
    height: 64px;
    background: var(--color-error, #dc2626);
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    margin: 0 auto var(--spacing);
  }

  .error-title {
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0 0 0.75rem 0;
    color: var(--color-text);
  }

  .error-message {
    font-size: 1rem;
    color: var(--color-text-secondary);
    margin: 0 0 0.5rem 0;
    line-height: 1.5;
  }

  .error-note {
    font-size: 0.9rem;
    color: var(--color-text-muted);
    margin: 0 0 var(--spacing) 0;
    padding: var(--spacing);
    background: var(--color-surface);
    border-radius: var(--radius);
  }

  .error-actions {
    display: flex;
    flex-direction: column;
    gap: var(--spacing);
    align-items: center;
    margin-top: var(--spacing);
  }

  .retry-button {
    padding: 0.75rem 1.5rem;
    background: var(--color-primary, #6366f1);
    color: white;
    border: none;
    border-radius: var(--radius);
    font-size: 0.95rem;
    font-weight: 500;
    cursor: pointer;
  }

  .retry-button:hover {
    background: #4f46e5;
  }

  /* Shared action link */
  .action-link {
    display: inline-block;
    padding: 0.5rem 1rem;
    background: var(--color-primary, #6366f1);
    color: white;
    text-decoration: none;
    border-radius: var(--radius);
    font-weight: 500;
  }

  .action-link:hover {
    opacity: 0.9;
  }
`;